import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CircularProgress,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { useState } from 'react';
import { iconColor } from 'styles/colors';
import { ICardAccordionProps, IStyleProps } from './types';
import useStyles from './style';
import ModalCard from '../../molecules/ModalCard';

const CardAccordion = ({
  children,
  ModalContent,
  title,
  subtitle,
  UpperRightIcon,
  clickable,
  values,
  expandCard,
  backgroundColor,
  isLoading,
  setExpandCard,
  upperRightIconCallback,
}: ICardAccordionProps) => {
  const [modalOpen, setModalOpen] = useState(false);

  const handleCardClick = () => setModalOpen(!modalOpen);
  const handleModalClose = () => setModalOpen(false);

  const classes = useStyles({
    color: backgroundColor,
    iconColor: iconColor(backgroundColor),
    hasSubtitle: !!subtitle,
    clickable,
  } as IStyleProps);

  return (
    <div>
      <Accordion
        className={isLoading ? classes.isLoading : classes.cardAccordion}
        expanded={expandCard}
        onChange={() => setExpandCard(!expandCard)}
      >
        <AccordionSummary
          expandIcon={isLoading ? null : <ExpandMoreIcon />}
          aria-controls="panel1c-content"
          id="panel1c-header"
        >
          {isLoading ? null : (
            <div className={classes.cardHeader}>
              <div className={classes.headerText}>
                <strong>{title}</strong>
                <span>
                  <p>{subtitle}</p>
                  <p>{values}</p>
                </span>
              </div>
              {UpperRightIcon && (
                <div
                  className={classes.headerIcon}
                  role="button"
                  tabIndex={0}
                  onKeyPress={upperRightIconCallback}
                  onClick={upperRightIconCallback}
                >
                  {UpperRightIcon}
                </div>
              )}
            </div>
          )}
        </AccordionSummary>
        <AccordionDetails
          onClick={clickable ? () => handleCardClick() : () => null}
        >
          {isLoading ? (
            <div className={classes.isLoading}>
              <CircularProgress
                aria-label="activity-status-loading"
                color="inherit"
                size={150}
              />
            </div>
          ) : (
            children
          )}
        </AccordionDetails>
      </Accordion>
      <ModalCard title={title} onClose={handleModalClose} open={modalOpen}>
        {ModalContent}
      </ModalCard>
    </div>
  );
};

export default CardAccordion;
